module.exports = __webpack_public_path__ + "static/media/(V)_MG_5905_-_Cia_Termal_Beachewear_-_Moda_Feminina.46f9fa4f.jpg";